import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';

//grid
import { AgGridNg2 } from 'ag-grid-angular';



import { ReporteDevolucion } from '../Models/ReporteDevolucion';
import {TipoTarea } from '../Models/TipoTarea';


import { GlobalsService } from '../services/globals.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';
import { UtilesService } from '../services/utiles.service';
import { VisitaTareaService } from '../services/visita-tarea.service';

@Component({
  selector: 'app-reporte-devoluciones',
  templateUrl: './reporte-devoluciones.component.html',
  styleUrls: ['./reporte-devoluciones.component.css']
})
export class ReporteDevolucionesComponent implements OnInit {


  public reporteDevolucionDetalle: ReporteDevolucion = new ReporteDevolucion();
  public reporteDevolucionDetalles: ReporteDevolucion[];

  public reporteDevolucionEnc: ReporteDevolucion = new ReporteDevolucion();
  public reporteDevolucionesEnc: ReporteDevolucion[];

  public tipoTarea: TipoTarea = new TipoTarea();
  public tipoTareas: TipoTarea[];

  public fechaInicio: Date;
  public fechaFin: Date;
  public numeroDodumento: string;

  public mostrarDetalle: boolean = false;

  constructor(private reporteService: ReporteViajeService, private globalServices: GlobalsService,
  private utilesService:UtilesService, private visitaTareaService:VisitaTareaService) {

  }

  ngOnInit() {
    this.CargarTiposTareas();
  }



  CargarReporteDevoluciones() {
    try {
     
     
      if (this.fechaInicio === null) {
        this.fechaInicio = undefined;
      }

      if (this.fechaInicio === undefined || this.fechaInicio.toString() == "") {
        this.fechaInicio = null;
      }

      if (this.fechaFin === null) {
        this.fechaFin = undefined;
      }

      if (this.fechaFin === undefined || this.fechaFin.toString() == "") {
        this.fechaFin = null;
      }
      if (this.numeroDodumento === undefined || this.numeroDodumento === "") {
        this.numeroDodumento = null;
      }


      this.reporteService.ObtenerReporteEncabezadoDevolucion(this.globalServices.ObtenerCompania(),
      this.numeroDodumento,this.fechaInicio,this.fechaFin, this.tipoTarea.tipo).subscribe(
          data => {
            this.reporteDevolucionesEnc = data;

          },
          err => {
            console.clear();
            console.log(err._body);

          });


    } catch (error) {
      console.log("cargar CargarReporteViajes: " + error);
    }

  }


  CargarReporteDevolucionesDetalle(idVisita: string) {
    try {
     
      this.reporteService.ObtenerReporteDetalleEncabezado(this.globalServices.ObtenerCompania(),idVisita).subscribe(
          data => {
            this.reporteDevolucionDetalles = data;

          },
          err => {
            console.clear();
            console.log(err._body);

          });


    } catch (error) {
      console.log("cargar CargarReporteDevolucionesDetalle: " + error);
    }

  }

  RegistroSeleccionado(item) {

    this.reporteDevolucionEnc = JSON.parse(JSON.stringify(item));

    this.CargarReporteDevolucionesDetalle(this.reporteDevolucionEnc.idVisita);

 this.mostrarDetalle=true;
  }


  Regresar(){
    this.mostrarDetalle=false;
    this.reporteDevolucionEnc=new ReporteDevolucion();
    this.reporteDevolucionDetalles=[];
    this.reporteDevolucionDetalle=new ReporteDevolucion;


  }


  CargarTiposTareas() {
    try {
     

      this.visitaTareaService.ObtenerTipoTareas().subscribe(
          data => {
            this.tipoTareas = data;

          },
          err => {
            console.clear();
            console.log(err._body);

          });


    } catch (error) {
      console.log("CargarTiposTareas: " + error);
    }

  }

}
